// src/firebase-config.js
// cSpell:ignore firestore firebaseapp rtdb firebasestorage

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyB3zr5zMfQx7xEXK5OYlRaOF_KV2VNQtoA",
  authDomain: "lucky-dog-tavern-drink-list.firebaseapp.com",
  databaseURL:
    "https://lucky-dog-tavern-drink-list-default-rtdb.firebaseio.com",
  projectId: "lucky-dog-tavern-drink-list",
  storageBucket: "lucky-dog-tavern-drink-list.firebasestorage.app",
  messagingSenderId: "4502204718",
  appId: "1:4502204718:web:19fd3fea061f6f6ec38abf",
  measurementId: "G-G3W05PEN2B",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const analytics = getAnalytics(app);
